import { render, staticRenderFns } from "./MapChange.vue?vue&type=template&id=80f32276&scoped=true&"
import script from "./MapChange.vue?vue&type=script&lang=js&"
export * from "./MapChange.vue?vue&type=script&lang=js&"
import style0 from "./MapChange.vue?vue&type=style&index=0&id=80f32276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f32276",
  null
  
)

export default component.exports